import { render, staticRenderFns } from "./RefundPolicy.vue?vue&type=template&id=d6663af2&scoped=true&"
var script = {}
import style0 from "./RefundPolicy.vue?vue&type=style&index=0&id=d6663af2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6663af2",
  null
  
)

export default component.exports